import { User } from './types';

export const generateCompensationOptions = (): number[] => {
  const options = [];
  for (let i = 0.5; i <= 3.0; i += 0.25) {
    options.push(i);
  }
  return options;
};

export const filterUsers = (users: User[], searchTerm: string): User[] => {
  return users.filter(user => {
    const searchLower = searchTerm.toLowerCase();
    
    // Search in name
    const nameMatch = `${user.firstName} ${user.lastName}`.toLowerCase().includes(searchLower);
    
    // Search in email
    const emailMatch = user.email.toLowerCase().includes(searchLower);
    
    // Search in roles
    const roleMatch = user.roles?.some(role => 
      role.toLowerCase().includes(searchLower)
    ) || false;
    
    // Search in licensed states (both full name and abbreviation)
    const stateMatch = user.licensedStates?.some(state => 
      state.toLowerCase().includes(searchLower)
    ) || false;
    
    return nameMatch || emailMatch || roleMatch || stateMatch;
  });
};

export const getLoanOfficers = (users: User[]): User[] => {
  return users.filter(user => user.roles?.includes('Loan Officer'));
};

export const getStatesOptions = (): string[] => {
  return [
    "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware",
    "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky",
    "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi",
    "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico",
    "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania",
    "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont",
    "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"
  ];
};

export const getRoleOptions = (): string[] => {
  return [
    "Admin",
    "Manager",
    "Loan Officer",
    "Processing",
    "Underwriter"
  ];
};